export default "__VITE_ASSET__DfvHJssa__"